function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeContainerStyles = function makeContainerStyles(_ref) {
  var breakpoints = _ref.breakpoints,
    primitives = _ref.primitives;
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          "&.DhigSplitButton--wrapper": {
            position: "relative",
            width: "fit-content",
            margin: "unset"
          },
          "&.DhigCircularProgress--wrapper": {
            width: "fit-content",
            margin: "0",
            padding: "0",
            "& .DhigCircularProgress--container": {
              justifyContent: "center",
              position: "relative",
              padding: "0",
              width: "unset",
              "& .DhigCircularProgress--label": {
                display: "flex",
                position: "absolute",
                wordBreak: "break-word",
                "&.DhigCircularProgress--label--medium": {
                  width: "30px"
                },
                "&.DhigCircularProgress--label--large": {
                  width: "70px"
                }
              }
            },
            "& .DhigCircularProgress--label--determinate": {
              justifyContent: "center",
              padding: primitives.spacings["0"],
              "&.DhigCircularProgress--label--determinate--medium": {
                marginTop: primitives.spacings["3"],
                marginLeft: primitives.spacings["0"]
              },
              "&.DhigCircularProgress--label--determinate--notMedium": {
                marginTop: primitives.spacings["0"],
                marginLeft: primitives.spacings["2"]
              }
            }
          },
          "&:not([class*='DhigSplitButton--wrapper'], [class*='DhigCircularProgress'])": {
            maxWidth: "calc(".concat(primitives.grid["max-width"], " / 0.9)"),
            padding: 0,
            "& > div": _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, breakpoints.up(breakpoints.values.xs), {
              margin: "0 ".concat(primitives.grid.margins["sm"])
            }), breakpoints.up(breakpoints.values.md), {
              margin: "0 ".concat(primitives.grid.margins["md"])
            }), breakpoints.up(breakpoints.values.lg), {
              margin: "0 ".concat(primitives.grid.margins["lg"])
            }), breakpoints.up(breakpoints.values.xl), {
              margin: "0 ".concat(primitives.grid.margins["xl"])
            })
          }
        }
      }
    }
  };
};